import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/header";
import Footer from "./components/footer";
import ConsentPopup from "./components/ConsentPopup";
import MenuModal from "./components/MenuModal"; // ✅ Import Modal
import { FaRobot } from "react-icons/fa"; // ✅ Floating Button Icon

import Home from "./pages/home";
import Contact from "./pages/contact";
import Collaborate from "./pages/collaborate";
import Properties from "./pages/properties";
import PropertyDetails from "./pages/propertydetail";
import Blogs from "./pages/blogs";
import BlogDetails from "./pages/blogDetails";
import AboutEqera from "./components/aboutsection";
import TermsAndConditions from "./pages/terms";
import PrivacyPolicy from "./pages/privacy";
import ScrollToTop from "./components/ScrollToTop";
import Faqs from "./pages/faqs";
import Video from "./pages/Video";
import NotFound from "./pages/NotFound";

import "./i18n";
import "./styles/floatingButton.css"; // ✅ Add this if you place button styles here

function App() {
  const [showMenuModal, setShowMenuModal] = useState(false);

  return (
    <Router>
      <Header />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/collaborate" element={<Collaborate />} />
        <Route path="/properties/:id" element={<PropertyDetails />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:id" element={<BlogDetails />} />
        <Route path="/about" element={<AboutEqera />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/video" element={<Video />} />
        <Route path="/NotFound" element={<NotFound />} />


      </Routes>

      <ConsentPopup />
      <Footer />

      {/* Floating Button */}
      <button
        className="floating-ai-button"
        onClick={() => setShowMenuModal(true)}
      >
        <FaRobot />
      </button>

      {/* Modal Component */}
      {showMenuModal && <MenuModal onClose={() => setShowMenuModal(false)} />}
    </Router>
  );
}

export default App;
